import { Box, TextField } from '@mui/material';
import React from 'react';

import { SectionLabel } from './SectionLabel';
import { FieldErrors } from '../types';

export interface ReferenceFieldsProps {
  reference1: string;
  reference2: string;
  reference3: string;
  reference1Required?: boolean;
  reference2Required: boolean;
  reference3Required: boolean;
  onChange: (key: 'referenceNo1' | 'referenceNo2' | 'referenceNo3', value: string) => void;
  errors: FieldErrors;
  locked?: boolean;
}

export const ReferenceFields: React.FC<ReferenceFieldsProps> = ({
  reference1,
  reference2,
  reference3,
  reference1Required,
  reference2Required,
  reference3Required,
  onChange,
  errors,
  locked,
}) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
    <SectionLabel label="Reference 1" required={reference1Required} locked={locked}>
      <TextField
        fullWidth
        size="small"
        value={reference1}
        onChange={(e) => onChange('referenceNo1', e.target.value)}
        error={!!errors.reference1}
        helperText={errors.reference1}
        slotProps={{ htmlInput: { 'aria-label': 'Reference 1' } }}
        disabled={locked}
      />
    </SectionLabel>
    {reference2Required && (
      <SectionLabel label="Reference 2" required locked={locked}>
        <TextField
          fullWidth
          size="small"
          value={reference2}
          onChange={(e) => onChange('referenceNo2', e.target.value)}
          error={!!errors.reference2}
          helperText={errors.reference2}
          slotProps={{ htmlInput: { 'aria-label': 'Reference 2' } }}
          disabled={locked}
        />
      </SectionLabel>
    )}
    {reference3Required && (
      <SectionLabel label="Reference 3" required locked={locked}>
        <TextField
          fullWidth
          size="small"
          value={reference3}
          onChange={(e) => onChange('referenceNo3', e.target.value)}
          error={!!errors.reference3}
          helperText={errors.reference3}
          slotProps={{ htmlInput: { 'aria-label': 'Reference 3' } }}
          disabled={locked}
        />
      </SectionLabel>
    )}
  </Box>
);
